// Auto generated file, do not manually modify!
// com.hotpads.rins.api.web.handler.UpsellWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ClickUpsellWebApiRequestDto,
  CreateUpsellWebApiRequestDto,
  CreateUpsellWebApiResponseDto,
  OptOutFromUpsellWebApiRequestDto,
  ShouldDisplayUpsellWebApiRequestDto,
  ViewUpsellWebApiRequestDto,
} from '../..';

export const UpsellWebApiHandler_clickUpsell_Path = '/api/web/v1/upsell/clickUpsell';

/**
 * user clicks an upsell
 */
export const UpsellWebApiHandler_clickUpsell = (postData: ClickUpsellWebApiRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, ClickUpsellWebApiRequestDto, void>(
    {
      endpoint: UpsellWebApiHandler_clickUpsell_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};

export const UpsellWebApiHandler_createUpsell_Path = '/api/web/v1/upsell/createUpsell';

/**
 * creates an upsell using a tracking id
 */
export const UpsellWebApiHandler_createUpsell = (postData: CreateUpsellWebApiRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, CreateUpsellWebApiRequestDto, CreateUpsellWebApiResponseDto>(
    {
      endpoint: UpsellWebApiHandler_createUpsell_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};

export const UpsellWebApiHandler_optOutFromUpsell_Path = '/api/web/v1/upsell/optOutFromUpsell';

/**
 * user opts out from upsells
 */
export const UpsellWebApiHandler_optOutFromUpsell = (
  postData: OptOutFromUpsellWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, OptOutFromUpsellWebApiRequestDto, void>(
    {
      endpoint: UpsellWebApiHandler_optOutFromUpsell_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};

export const UpsellWebApiHandler_shouldDisplayUpsell_Path = '/api/web/v1/upsell/shouldDisplayUpsell';

/**
 * should an upsell be displayed to a user
 */
export const UpsellWebApiHandler_shouldDisplayUpsell = (
  postData: ShouldDisplayUpsellWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ShouldDisplayUpsellWebApiRequestDto, boolean>(
    {
      endpoint: UpsellWebApiHandler_shouldDisplayUpsell_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};

export const UpsellWebApiHandler_viewUpsell_Path = '/api/web/v1/upsell/viewUpsell';

/**
 * user views an upsell
 */
export const UpsellWebApiHandler_viewUpsell = (postData: ViewUpsellWebApiRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, ViewUpsellWebApiRequestDto, void>(
    {
      endpoint: UpsellWebApiHandler_viewUpsell_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};
